export default __webpack_public_path__ + "static/media/closePopup.bafef753.svg";